import React, {useState, useEffect} from "react";

export default function GetProducts(filter){
  const [Products, SetProducts] = useState([])

  useEffect(() => {
    const fetchProducts = async () => {
      const result = await fetch(import.meta.env.VITE_URL + '/products.json');
      const jsonresult = await result.json()
      SetProducts(jsonresult)
    }
    fetchProducts();
  }, [])


  if (filter == "Roll"){
    const filteredProducts = [];
    const Carpets = Products.filter(p => p.product_type == "Carpet");
    const Vinyls = Products.filter(p => p.product_type == "Vinyl");
    const Mattings = Products.filter(p => p.product_type == "Matting");

    filteredProducts.push(...Carpets);
    filteredProducts.push(...Vinyls);
    filteredProducts.push(...Mattings);

    return filteredProducts;

  }
  else if (filter == "Pack"){
    return Products.filter(p => p.product_type == filter)
  }
}
